import request from "@/utils/request";

// 转发加价
export function priceMarkup(data) {
  return request({
    url: "/product/activity/forward/price-markup",
    method: "post",
    data,
  });
}
// 转发详情
export function forwardDetail(params) {
  return request({
    url: "/product/activity/forward-detail",
    method: "get",
    params,
  });
}

// 转发抽奖专场
export function lotteryShare(params) {
  return request({
    url: '/product/special-award/forward',
    method: 'get',
    params
  })
}
// 转发双倍佣金专场
export function doubleShare(params) {
  return request({
    url: '/product/special-double/forward',
    method: 'get',
    params
  })
}
// 转发新人专场
export function newcomerShare(params) {
  return request({
    url: '/product/special-newbie/forward',
    method: 'get',
    params
  })
}
// 转发好评TOP榜
export function topShare(params) {
  return request({
    url: '/product/top-goods/h5/forward',
    method: 'get',
    params
  })
}